var a = Object.defineProperty;
var n = (e, o, s) => o in e ? a(e, o, { enumerable: !0, configurable: !0, writable: !0, value: s }) : e[o] = s;
var t = (e, o, s) => n(e, typeof o != "symbol" ? o + "" : o, s);
import { makeAutoObservable as r } from "mobx";
import { debounce as d } from "./chunk321.js";
class L {
  constructor() {
    t(this, "_isLoading", !1);
    r(this);
  }
  get isLoading() {
    return this._isLoading;
  }
  setIsLoading(o) {
    this._isLoading = o;
  }
}
const i = new L(), h = () => {
  i.setIsLoading(!0);
}, c = d(() => {
  i.setIsLoading(!1);
}, 300), b = () => {
  c();
};
export {
  L as MainLoaderStore,
  b as hideLoader,
  i as mainLoaderStore,
  h as showLoader
};
